import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {FiDribbble} from 'react-icons/fi'
// import {BsFacebook} from 'react-icons/bs'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
      <a href="https://www.linkedin.com/in/vanessa-badien/" target="_blank"><BsLinkedin /></a>
      <a href="https://github.com/BadienVanessa" target="_blank"><FaGithub /></a>
      {/* <a href="https://dribbble.com" target="_blank"><FiDribbble /></a> */}
      {/* <a href="https://facebook.com" target="_blank"><BsFacebook /></a> */}
    </div>
  )
}

export default HeaderSocials
